module.exports = __webpack_public_path__ + "static/NightInTheWoods0-e4ef366b6c2d60a656ba87bfe6e6e98b.webp";